/**
 * Zod-Schema fuer die oeffentliche Buchungs-Seite (BookingPage).
 *
 * Phase 3 der Forms-Migration auf react-hook-form + zod
 * (siehe docs/runbooks/FORMS_MIGRATION_PLAN.md).
 *
 * Die Seite war bereits zod-validiert (manueller safeParse-Loop) —
 * dieser Schema-Export ist die direkte Uebernahme, jetzt aber via
 * zodResolver vom RHF-Form selbst angewendet. Trims auf Freitext-
 * Feldern, damit Whitespace-only-Eingaben nicht durchrutschen und
 * der Submit-Payload trotzdem getrimmte Werte hat (vorher passierte
 * das in `bookingsRepo.createBookingRequest`-Aufrufer-Code).
 */
import { z } from 'zod';

export const APPOINTMENT_TYPES = ['in_person', 'online', 'phone'] as const;
export type AppointmentType = (typeof APPOINTMENT_TYPES)[number];

export const PREFERRED_TIMES = ['morgens', 'mittags', 'nachmittags'] as const;
export type PreferredTime = (typeof PREFERRED_TIMES)[number];

export const bookingSchema = z.object({
  name: z
    .string()
    .trim()
    .min(2, 'Name muss mindestens 2 Zeichen haben')
    .max(100),
  email: z
    .string()
    .trim()
    .email('Bitte eine gueltige E-Mail-Adresse eingeben'),
  // Telefon ist optional; leerer String bleibt erlaubt (UI legt ihn
  // nach dem Submit auf null um). Nur wenn etwas eingegeben wurde,
  // pruefen wir die Maximal-Laenge.
  phone: z
    .string()
    .trim()
    .max(30)
    .optional()
    .default(''),
  preferred_date: z.string().min(1, 'Bitte ein Wunschdatum angeben'),
  preferred_time: z.enum(PREFERRED_TIMES),
  appointment_type: z.enum(APPOINTMENT_TYPES),
  message: z
    .string()
    .trim()
    .max(1000, 'Nachricht darf maximal 1000 Zeichen haben')
    .optional()
    .default(''),
});

export type BookingInput = z.infer<typeof bookingSchema>;
